import { COOKIE_DEVICE_ID } from 'common/cookies/Cookies';
import { getDeviceIdCookieProperties } from 'common/cookies/CookieUtils';
import Cookies from 'js-cookie';
import { v4 as uuid } from 'uuid';
import { getDomain } from './route-utils';

export const getBrowserTrackerId = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  return Cookies.get(COOKIE_DEVICE_ID) ?? null;
};

export const setBrowserTrackerId = (browserTrackerId: string): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const domain = getDomain(window.location.hostname);
  const properties = getDeviceIdCookieProperties(domain);
  Cookies.set(COOKIE_DEVICE_ID, browserTrackerId, properties);
};

export const getOrCreateBrowserTrackerId = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const existingBrowserTrackerId = getBrowserTrackerId();

  if (existingBrowserTrackerId) {
    return existingBrowserTrackerId;
  }

  const browserTrackerId = uuid();
  setBrowserTrackerId(browserTrackerId);
  return browserTrackerId;
};
